<lib-container class="my_assessments" title="My Assessments" style="width: 100%; margin-bottom: 2rem;">

  <div>
    @if (isMobileView) {
      <div class="expand-button" (click)="toggleExpand()">
        {{ isExpanded ? 'Show Less' : 'Show All' }}
      </div>
    }
  </div>

  <table *ngIf="my_assessments.length > 0" mat-table [dataSource]="my_assessments">
    <ng-container [matColumnDef]=MY_ASSESSMENT_COLUMNS.NAME>
      <th mat-header-cell *matHeaderCellDef>Assessment</th>
      <td class="assessment_name" mat-cell *matCellDef="let ref">{{ ref.assessment_name }}</td>
    </ng-container>
    
    <ng-container [matColumnDef]=MY_ASSESSMENT_COLUMNS.STATUS>
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell class="statuses" *matCellDef="let ref">
        
        <span *ngIf="!ref.completed_at" matTooltip="{{ ref.close_dt }} ">
          <mat-basic-chip class="open">Open</mat-basic-chip>
        </span>
       
        <span *ngIf="ref.completed_at">
          <mat-basic-chip class="completed">Done</mat-basic-chip>
        </span>

      </td>
    </ng-container>

    <ng-container [matColumnDef]=MY_ASSESSMENT_COLUMNS.ITERATION>
      <th mat-header-cell *matHeaderCellDef>Iteration</th>
      <td mat-cell *matCellDef="let ref">{{ ref.iteration }}</td>
    </ng-container>

      <ng-container [matColumnDef]=MY_ASSESSMENT_COLUMNS.COMPLETE>
      <th mat-header-cell *matHeaderCellDef>Complete By</th>
      <td mat-cell *matCellDef="let ref">{{ ref.close_dt }}</td>
    </ng-container>

    <ng-container [matColumnDef]=MY_ASSESSMENT_COLUMNS.ACTIONS>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let ref, let i = index">

        @if (!isSuperAdmin && ref.completed_at && ref.require_approval === 1 && !ref.approved_at) {
          <!-- Awaiting Approval Message -->
          <span>
            Awaiting Approval
          </span>
        }
        @else {
          <mat-icon 
            data-testid="row-menu-trigger"
            [matMenuTriggerFor]="my_menu"   
            (click)="$event.stopPropagation()">more_horiz
          </mat-icon>

          <mat-menu #my_menu="matMenu">
            <div class="menu-actions">Actions</div>

            <mat-divider></mat-divider>

            @if (ref.completed_at && (ref.require_approval === 0 || (ref.require_approval === 1 && ref.approved_at))) {
              <button mat-menu-item>
                <span class="options" (click)="view(ref)">View Report</span>
              </button>

              <button
                mat-menu-item
                type="button"
                data-testid="download-report-button"
                [disabled]="downloadingId === ref.org_person_assessment_id"
                [attr.aria-busy]="downloadingId === ref.org_person_assessment_id"
                matTooltip="Preparing this report"
                [matTooltipDisabled]="downloadingId !== ref.org_person_assessment_id"
                (click)="downloadReport(ref)">
                <span class="options">Download PDF</span>
                @if (downloadingId === ref.org_person_assessment_id) {
                  <mat-spinner data-testid="download-spinner" diameter="18" mode="indeterminate"></mat-spinner>
                }
              </button>
            }

            @if (isSuperAdmin && ref.completed_at && ref.require_approval === 1 && !ref.approved_at) {
              <button mat-menu-item>
                <span class="options" (click)="approve(ref)">Approve</span>
              </button>
            }

            @if (!ref.completed_at) {
              <button mat-menu-item>
                <span class="options" (click)="complete(ref)">Complete</span>
              </button>
            }

            <div class="menu-actions">Connections</div>

            <mat-divider></mat-divider> 

            <button mat-menu-item>
              <span class="options" (click)="goToProfile()">View Profile</span>
            </button>
          </mat-menu>
        }
        
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="isMobileView && !isExpanded ? MY_ASSESSMENT_COLUMNS_MOBILE_VIEW_KEYS : MY_ASSESSMENT_COLUMN_KEYS"></tr>
    <tr
      class="row"
      data-testid="assessment-row"
      mat-row
      *matRowDef="let row; columns: isMobileView && !isExpanded ? MY_ASSESSMENT_COLUMNS_MOBILE_VIEW_KEYS : MY_ASSESSMENT_COLUMN_KEYS; let i = index"
      (click)="viewRow(row, i)">
    </tr>

  </table>

  <div *ngIf="my_assessments.length === 0">
    <p>No current assessments found</p>
  </div>

</lib-container>